import axioslib, { AxiosInstance, AxiosRequestConfig } from "axios";
import { AuthInterceptor } from "./AuthInterceptor";
import VersionInterceptor from "@/api/VersionInterceptor";
import { Logger } from "@iloq/shared";
import { User } from "@iloq/shared";

export default class UserApi {
  private readonly axios: AxiosInstance;

  constructor() {
    this.axios = axioslib.create();
    AuthInterceptor.setAuthInterceptors(this.axios);
    VersionInterceptor.setVersionInterceptor(this.axios);
  }

  fetchUser(): Promise<User> {
    const options: AxiosRequestConfig = {
      method: "POST",
      url: "/user/me",
    };
    return this.axios(options)
      .catch((error) => {
        Logger.error("UserApi.fetchUser failed:", error);
        return Promise.reject(error);
      })
      .then((result) => {
        Logger.debug("UserApi.fetchUser result data:", result.data);
        return new User(
          result.data.firstName,
          result.data.lastName,
          result.data.email,
          result.data.permissions,
          result.data.groups,
          result.data.languageCode,
          result.data.countryCode,
          result.data.partnerId,
          result.data.subsidiaryId,
        );
      });
  }

  async gdprConsent(consent: boolean): Promise<void> {
    const options: AxiosRequestConfig = {
      method: "PUT",
      url: "/api/v1/user/gdpr-consent",
      data: {
        consent,
      },
    };
    return this.axios(options)
      .catch((error) => {
        Logger.error("UserApi.gdprConsent failed:", error);
        return Promise.reject(error);
      })
      .then(() => {
        Logger.debug("UserApi.gdprConsent done");
      });
  }
}
